module.exports = __webpack_public_path__ + "img/e48bf576efc243ba8fe8fe9abc685267.mp4";